export default "__VITE_ASSET__K3yVmMAv__"